import { useEffect } from 'react'
import { OfferPage, type OfferPageBrand } from '../components/offer/OfferPage'

// freightratesmcp.com/offer/:id, the page a forwarder's client opens from an offer link. It stands alone:
// no site header or footer and no locale prefix, because it is the forwarder's page for their client, who
// has never heard of us. The forwarder leads; FreightRatesMCP is named as the service that delivers it.

const PRODUCT_BRAND: OfferPageBrand = {
  mark: (doc) =>
    doc ? (
      <>
        <b>{doc.member}</b>
        <i>via</i>
        <span className="op-member">FreightRatesMCP</span>
      </>
    ) : (
      <span className="op-member">FreightRatesMCP</span>
    ),
  powered: {
    en: 'Offer delivered by FreightRatesMCP',
    zh: '报价由 FreightRatesMCP 提供',
  },
  app: (member) => member,
  simulated: {
    en: 'Simulated sign-in: WeChat is not contacted, and only the name you enter is recorded.',
    zh: '模拟授权：不会连接微信，只记录您填写的昵称。',
  },
}

export function CustomerOfferPage({ id }: { id: string }) {
  // One forwarder's offer to one client: never in search results (the Worker also sends noindex).
  useEffect(() => {
    const m = document.createElement('meta')
    m.name = 'robots'
    m.content = 'noindex'
    document.head.appendChild(m)
    return () => m.remove()
  }, [])
  return <OfferPage id={id} brand={PRODUCT_BRAND} />
}

/** The offer id in a /offer/:id path, or null. Root only: offer pages carry no locale prefix. */
export const offerIdFromPath = (pathname: string): string | null =>
  pathname.match(/^\/offer\/([a-z0-9-]+)\/?$/)?.[1] ?? null
